import { useSelector } from 'react-redux';
import { getOnlineBookingState } from 'reducers/onlineBooking/OnlineBookingSelectors';

export const useOnlineBookingState = () => {
    return useSelector(getOnlineBookingState);
};
